import classNames from 'classnames';
import { KeyboardEvent } from 'react';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { TestBem } from '../../../service/TestBem';
import { KeyCode } from '../../../typings/common';
import { TextInputDecorator } from '../../TextInputDecorator/TextInputDecorator';
import { PhrasesSelectorControlButtons } from '../PhrasesSelectorControlButtons/PhrasesSelectorControlButtons';

import './PhrasesSelectorMinusPhrasesEditForm.css';

export interface PhrasesSelectorMinusPhrasesEditFormProps {
    phrase: string;
    onCancel: () => void;
    onSave: (phrase: string) => void;
}

interface PhrasesSelectorMinusPhrasesEditFormState {
    value: string;
}

const BLOCK = 'phrases-selector-minus-phrases-edit';

export class PhrasesSelectorMinusPhrasesEditForm extends React.PureComponent<
    PhrasesSelectorMinusPhrasesEditFormProps,
    PhrasesSelectorMinusPhrasesEditFormState
> {
    state = {
        value: this.props.phrase
    };

    render() {
        const { value } = this.state;
        const { onCancel } = this.props;

        return (
            <div className={Bem.cls(BLOCK)}>
                <TextInputDecorator
                    autoFocus={true}
                    text={value}
                    theme="normal"
                    view="classic"
                    size="s"
                    cls={classNames(Bem.cls(BLOCK, 'input'), TestBem.cls(BLOCK, 'input'))}
                    onChange={this.onChange}
                    onKeyDown={this.onInputKeydown}
                />
                <PhrasesSelectorControlButtons onAccept={this.onSave} onReject={onCancel} />
            </div>
        );
    }

    private onInputKeydown = (event: KeyboardEvent<HTMLElement>) => {
        if (event.keyCode === KeyCode.RETURN) {
            this.onSave();
        }
    };

    private onSave = () => {
        const { value } = this.state;
        const { onSave } = this.props;

        onSave(value);
    };

    private onChange = (value: string) => {
        this.setState({ value });
    };
}
